import { apiFetch } from './apiClient.js';

/**
 * #165 — Cliente UI para webhook-config (360dialog).
 * Backend: services/tenant-mgmt/src/handlers/providerWebhook.ts (#93).
 *
 * Solo aplica a connectors provider=360dialog. Meta Cloud configura el
 * webhook desde el dashboard de Meta App — no expone API HTTP.
 */

export interface ProviderWebhookConfig {
  url: string | null;
  meta?: Record<string, unknown>;
}

export async function getProviderWebhook(
  tenantId: string,
  connectorId: string,
): Promise<ProviderWebhookConfig> {
  return apiFetch<ProviderWebhookConfig>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/connectors/${encodeURIComponent(connectorId)}/webhook-config`,
  );
}

export async function setProviderWebhook(
  tenantId: string,
  connectorId: string,
  url: string,
): Promise<void> {
  await apiFetch<void>(
    `/v1/tenants/${encodeURIComponent(tenantId)}/connectors/${encodeURIComponent(connectorId)}/webhook-config`,
    { method: 'PUT', body: { url } },
  );
}
